import "./auto-select-section.css";

import { RadioGroup, Switch } from "@tql/ui-components-react/kendo/inputs";

import type { AutoSelectOption, CarrierRule } from "../../utils/types";

const AUTO_SELECT_OPTIONS = [
	{ label: "Lowest Cost Carrier", value: "lowestCost" },
	{
		label: "Lowest Cost and Fastest Transit Time",
		value: "lowestCostAndTransitTime",
	},
];

type AutoSelectSectionProps = {
	readonly isActive: boolean;
	readonly onToggle: (value: boolean) => void;
	readonly method: AutoSelectOption;
	readonly onMethodChange: (value: AutoSelectOption) => void;
	readonly carriers: CarrierRule[];
};

export function AutoSelectSection({
	isActive,
	onToggle,
	method,
	onMethodChange,
	carriers,
}: AutoSelectSectionProps) {
	const hasFilledCarrier = carriers.some(
		(c) => c.fieldSelector !== "" && c.field1.value !== "" && c.operator !== "",
	);
	return (
		<div>
			Auto Select
			<div className={"auto-select-controls"}>
				{isActive ? "On" : "Off"}
				<Switch
					checked={isActive}
					disabled={!hasFilledCarrier}
					onChange={(e) => {
						const value: unknown = e.value;
						if (typeof value === "boolean") {
							onToggle(value);
						}
					}}
				/>
				<RadioGroup
					data={AUTO_SELECT_OPTIONS}
					disabled={!hasFilledCarrier}
					layout={"horizontal"}
					onChange={(e) => {
						const value: unknown = e.value;
						if (
							value === "lowestCost" ||
							value === "lowestCostAndTransitTime"
						) {
							onMethodChange(value);
						}
					}}
					value={method}
				/>
			</div>
		</div>
	);
}
